import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'services/redux/configureStore';

export function RouteWithAuth({ children }: { children: JSX.Element }) {
  const location = useLocation();

  const { isAuth } = useAppSelector((state) => state.auth);

  if (!isAuth) {
    return <Navigate to={'/login'} state={{ from: location }} replace />;
  }

  return children;
}
